export default "__VITE_ASSET__DD$C$Q5m__"